module.exports = __webpack_public_path__ + "static/media/plus.a67e272b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus.svg
// module id = 1204
// module chunks = 0